import { NavItemWithChildren } from '@app/components/layout/sidenav/link/NavItemWithChildren';
import { useIntl } from 'react-intl';
import { SearchIcon } from '../SearchIcon';
export function SearchLinks() {
  const { $t } = useIntl();

  return (
    <NavItemWithChildren
      root="/search"
      label={$t({
        id: 'search.title',
        defaultMessage: 'Búsqueda',
      })}
      icon={<SearchIcon />}
    />
  );
}
